export default (initUrl) => ({
  url: initUrl,
  init() {

  },
  showWidget() {
    if (!window.calScript) {
      window.calScript = document.createElement('script');
      window.calScript.src = 'https://assets.calendly.com/assets/external/widget.js';
      window.calScript.onload = () => Calendly.initPopupWidget({url: this.url});
      var calStyle = document.createElement('link');
      calStyle.href = 'https://assets.calendly.com/assets/external/widget.css';
      calStyle.rel = 'stylesheet';
      document.body.append(window.calScript, calStyle);
    } else {
      Calendly.initPopupWidget({url: this.url});
    }
  },
})